<template>
    <div>
        <!--<div v-if="archived" slot="header">{{ archivedTitle }}</div>-->
        <h1>Dalībnieki</h1>
        <v-progress-circular
                v-show="loadingCaterers"
                class="caterers__loading"
                :size="70"
                :width="7"
                color="green"
                indeterminate
        ></v-progress-circular>

        <div v-show="!loadingCaterers" class="caterers__content">
            <v-container grid-list-md>
                <v-layout class="caterers__grid-layout-fix" wrap justify-center>
                    <v-flex shrink v-for="(caterer, index) in catererList" :key="index">
                        <v-dialog v-model="caterer.Id" content-class="caterers__dialog" v-on:input="toggleDialogEvent($event)" lazy maxWidth="900px">

                            <template v-slot:activator="{ on }">
                                <v-card hover ripple v-on="on" width="320px" height="335px">
                                    <v-img :src="caterer.logo" height="200px">
                                        <template v-slot:placeholder>
                                            <v-layout fill-height align-center justify-center ma-0>
                                                <v-progress-circular indeterminate color="grey"></v-progress-circular>
                                            </v-layout>
                                        </template>
                                    </v-img>
                                    <v-card-title primary-title>
                                        <div>
                                            <div class="headline" v-text="caterer.name"></div>
                                        </div>
                                    </v-card-title>
                                    <v-card-subtitle>
                                        <span><b>Piedāvā: </b></span><span class="grey--text" v-text="caterer.offering"></span>
                                    </v-card-subtitle>
                                </v-card>
                            </template>

                            <v-card>

                                <v-btn icon light @click="caterer.Id = false">
                                    <v-icon>close</v-icon>
                                </v-btn>
                                <v-btn v-show="archived" v-if="isAuthenticated" icon light @click="copyCaterer(caterer.docId)">
                                    <v-icon>mdi-file-replace-outline</v-icon>
                                </v-btn>
                                <v-btn v-show="!archived" v-if="isAuthenticated" icon light @click="confirmDeleteCaterer(caterer)">
                                    <v-icon>delete_outline</v-icon>
                                </v-btn>

                                <v-carousel class="caterers__carousel" v-if="dialogOpen" delimiter-icon="stop" prev-icon="mdi-arrow-left" next-icon="mdi-arrow-right">
                                    <v-carousel-item v-for="(image,i) in caterer.images" :key="i" :src="image" ></v-carousel-item>
                                </v-carousel>
                                <v-card-title primary-title>
                                    <div>
                                        <div class="headline" v-text="caterer.name"></div>
                                    </div>
                                </v-card-title>
                                <v-card-subtitle>
                                    <span><b>Piedāvā: </b></span><span class="grey--text" v-text="caterer.offering"></span>
                                </v-card-subtitle>
                                <v-card-text>
                                    <vue-markdown>{{caterer.description}}</vue-markdown>
                                </v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn target="_blank" :href="caterer.facebook" v-if="caterer.facebook.length" icon>
                                        <v-icon>fab fa-facebook</v-icon>
                                    </v-btn>
                                    <v-btn target="_blank" :href="caterer.instagram" v-if="caterer.instagram.length" icon>
                                        <v-icon>fab fa-instagram</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>

        <v-snackbar
                style="position: fixed; top: 50px;"
                v-model="notificationState"
                top
                absolute
                :color="notificationColor"
        >{{notificationText}}</v-snackbar>

        <v-dialog v-if="isAuthenticated" v-model="deleteDialog" max-width="290">
            <v-card>
                <v-card-title class="headline">Dzēst dalībnieku?</v-card-title>
                <v-card-text>
                    Dalībnieks tiks neatgriezeniski dzēsts:

                    <b>{{ deleteName }}</b>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn text small @click="deleteDialog = false">
                        Atcelt
                    </v-btn>

                    <v-btn dark small color="red"  @click="deleteCaterer()">
                        <v-icon>delete_outline</v-icon> Dzēst
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import firebaseCfg from "../firebaseConfig";
    import firebase from 'firebase/app';
    require('firebase/auth');
    import VueMarkdown from 'vue-markdown'

    export default {
        name: "CaterersBlock",
        components: {
            VueMarkdown
        },
        data() {
            return {
                notificationState: false,
                notificationText: '',
                notificationColor: '',

                isAuthenticated: false,
                loadingCaterers: true,

                dialogOpen: false,
                catererList: [],
                catererDialog: false,

                deleteDialog: false,
                deleteCatereriD: null,
                deleteName: null,
            }
        },
        props: {
            // like caterers2019q3
            catererCollection: String,
            archived: Boolean
        },
        methods: {
            pushNotification: function(color, text){
                this.notificationState = true;

                this.notificationColor = color;
                this.notificationText = text;

            },
            toggleDialogEvent: function( status ){
                this.$data.dialogOpen = status;
            },
            copyCaterer: function(docId){
                const that = this;

                firebaseCfg.db.collection(that.catererCollection).doc(docId).get().then(function(caterer){
                    const catererData = caterer.data();

                    firebaseCfg.db.collection('caterers2020q3').add({
                        createDate: firebase.firestore.Timestamp.fromDate(new Date()),
                        name: catererData.name,
                        offering: catererData.offering,
                        description: catererData.description,
                        logo: catererData.logo,
                        images: catererData.images,
                        instagram: catererData.instagram,
                        facebook: catererData.facebook
                    })
                        .then(function() {
                            that.pushNotification(
                                "green",
                                "Dlībnieks nokopēts."
                            );

                            that.updateCaterers();
                        })
                        .catch(function() {
                            that.pushNotification(
                                "red",
                                "Kļūda kopējot dalībnieku."
                            );
                        });
                });
            },
            updateCaterers: function(catererCollection){
                const that = this;
                const caterers = [];

                firebaseCfg.db.collection(catererCollection ? catererCollection : that.catererCollection).orderBy("createDate", "desc").get().then(function(querySnapshot){
                    querySnapshot.forEach(function(caterer){
                        const catererData = caterer.data();

                        catererData.docId = caterer.id;
                        caterers.push(catererData);
                    });

                    that.$data.catererList = caterers;
                    that.loadingCaterers = false;
                });
            },
            confirmDeleteCaterer: function(caterer){
                const that = this;

                that.deleteDialog = true;
                that.deleteCatereriD = caterer.docId;
                that.deleteName = caterer.name;
            },
            deleteCaterer: function(){
                const that = this;

                firebaseCfg.db.collection(that.catererCollection).doc(that.deleteCatereriD).delete().then(function() {
                    that.pushNotification(
                        "green",
                        "Dalībnieks veiksmīgi izdzēsts no saraksta."
                    );

                    that.catererList = that.catererList.filter(caterer => caterer.docId !== that.deleteCatereriD);
                    that.deleteCatereriD = null;
                    that.deleteName = null;
                    that.deleteDialog = false;
                }).catch(function() {
                    that.pushNotification(
                        "red",
                        "Kļūda dzēšot dalībnieku."
                    );
                });
            }
        },
        mounted() {
            const that = this;

            that.updateCaterers();

            firebase.auth().onAuthStateChanged(function(user) {
                if (user) {
                    that.isAuthenticated = true;
                } else {
                    that.isAuthenticated = false;
                }
            });
        }
    }
</script>

<style scoped>
    .caterers__loading {
        display: flex;
        margin: 35px auto;
    }
    .caterers h1 { text-align: center }
    .caterers__content {
        margin: 30px 0 0;
    }
    .caterers__more-caterers-card {
        cursor: default;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        text-align: center;
    }
    .caterers__grid-layout-fix {
        display: grid;
        grid-template-columns: repeat(auto-fit, 330px);
        grid-column-gap: 15px;
        grid-row-gap: 15px;
    }
</style>